import { DeathCancellationAnscNotificationsNonResidentMutationCrumbs } from 'mutation/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import CancellationNonResidentNotificationCivilStatusShared from 'shell/components/shared/ansc-notifications/research-death-non-resident/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const CancellationNonResidentNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <CancellationNonResidentNotificationCivilStatusShared
        items={DeathCancellationAnscNotificationsNonResidentMutationCrumbs()}
        scope={IdAmbito.Mutazioni}
      />
    </Fragment>
  );
};

CancellationNonResidentNotificationCivilStatusPage.displayName =
  'Research Death Detail Notifications Page component';

export default CancellationNonResidentNotificationCivilStatusPage;
